<article class="day-card">
  <header class="day-card-header">
    <div class="day-heading">
      <span class="day-name">{{ date() | date: "EEEE" }}</span>
      <span class="day-date">{{ date() | date: "d MMM y" }}</span>
    </div>
    @if (loggedHours()) {
      <span class="day-total-badge">{{ formatLoggedBadge() }}</span>
    }
  </header>

  <app-time-sheet-number-line
    [projectColorById]="projectColorById()"
    (onEntryClick)="openTimeSheetEntryModal($event)"
    (onCreateEntry)="openTimeSheetEntryModal($event)"
    [projects]="projects()"
    [entries]="sortedEntries()"
    [allowCreate]="!isFutureDay()"
  />

  @if (sortedEntries().length) {
    <button
      type="button"
      class="entries-toggle"
      [attr.aria-expanded]="entriesExpanded()"
      (click)="toggleEntriesExpanded()"
    >
      <i
        class="bi entries-toggle-icon"
        [class.bi-chevron-right]="!entriesExpanded()"
        [class.bi-chevron-down]="entriesExpanded()"
        aria-hidden="true"
      ></i>
      @if (entriesExpanded()) {
        Hide {{ entryCountLabel() }}
      } @else {
        Show {{ entryCountLabel() }}
      }
    </button>

    @if (entriesExpanded()) {
      <ul class="entry-list">
        @for (entry of sortedEntries(); track entry.id) {
          <li>
            <button
              type="button"
              class="entry-row"
              [class.entry-row--approved]="entry.approved"
              [disabled]="entry.approved"
              [attr.title]="entry.approved ? 'Approved' : null"
              (click)="openTimeSheetEntryModal(entry)"
            >
              <span class="entry-leading">
                <span
                  class="entry-project-dot"
                  [style.background-color]="projectColor(entry)"
                  aria-hidden="true"
                ></span>
                <span class="entry-text">
                  <span class="entry-project">{{ projectName(entry) }}</span>
                  <span class="entry-details">
                    <span class="entry-category">{{ entryCategory(entry) }}</span>
                    <span class="entry-separator" aria-hidden="true">|</span>
                    <span class="entry-description">{{
                      entryDescription(entry)
                    }}</span>
                  </span>
                </span>
              </span>
              <span class="entry-duration">{{
                formatEntryHours(entry.hours)
              }}</span>
            </button>
          </li>
        }
      </ul>
    }
  }
</article>
